
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => {
    return {
        footer: {
            position: 'absolute',
            display: "flex",
            justifyContent: "center",
            bottom: theme.spacing(4),
            width: '100%',
            "& button": {
                width: "40%",
            }
        },
        option: {
            '&[aria-selected="true"]': {
                backgroundColor: '#e3e3e3 !important',
            },
        },
        linkText: {
            color: theme.palette.primary.main,
            paddingLeft: theme.spacing(1)
        }
    };
});
